import { ENV } from 'constants/app'

declare const __WS_PATHNAME__: string | undefined
declare const __WS_PUBLIC_PATHNAME__: string | undefined
declare const __WS_SECURE__: boolean | undefined
declare const __WS_DISABLED__: boolean | undefined

export const WS_RECONNECT_TIMEOUT = 10 * 1000

const proto = __WS_SECURE__ ? 'wss' : 'ws'
const domain = ENV === 'prod' || ENV === 'stage' ? window.location.host : 'stage.tangledevelopment.com'
export const socketUrl = `${ proto }://${ domain }${ __WS_PATHNAME__ }`
export const publicSocketUrl = `${ proto }://${ domain }${ __WS_PUBLIC_PATHNAME__ }`

export const isWsEnabled = () => !__WS_DISABLED__
